// =========================
// 0. BLOKADA DOMYŚLNEGO SKOKU DO KOTWICY
// (musi wykonać się jak najwcześniej, zanim przeglądarka
// zdąży sama doskoczyć do #hash)
//
// UWAGA: samo scrollTo(0,0) na starcie nie wystarczy — przeglądarka
// potrafi doskoczyć do kotwicy ponownie (np. przy 'load' albo gdy
// zmieni się wysokość strony), co "nadpisuje" naszą blokadę.
// Dlatego najpewniej jest po prostu wyciąć hash z adresu URL,
// zapamiętać go sobie, i przywrócić dopiero po własnym scrollu.
// =========================


document.addEventListener('DOMContentLoaded', function () {

    // =========================
    // 1. FAST SCROLL (jump)
    // =========================
    function jumpTo(y) {
        window.scrollTo(0, y);
    }

    // =========================
    // 2. SMOOTH FINISH SCROLL
    // =========================
    function smoothScrollTo(y, duration = 350) {
        const start = window.scrollY;
        const diff = y - start;
        let startTime = null;

        const easeOutCubic = t => 1 - Math.pow(1 - t, 3);

        function step(timestamp) {
            if (!startTime) startTime = timestamp;

            const time = timestamp - startTime;
            const progress = Math.min(time / duration, 1);

            const eased = easeOutCubic(progress);

            window.scrollTo(0, start + diff * eased);

            if (time < duration) {
                requestAnimationFrame(step);
            }
        }

        requestAnimationFrame(step);
    }

    // =========================
    // RUN SCROLL (2-step UX)
    // =========================
    window.runScroll = function (el, offset = 0) {

        const targetEl = document.querySelector(el);
        if (!targetEl) return;

        const topbar = document.querySelector('#topbar');
        const topbarHeight = topbar ? topbar.offsetHeight : 0;

        const targetTop =
            targetEl.getBoundingClientRect().top + window.scrollY;

        const finalPosition = targetTop - topbarHeight - offset;

        const current = window.scrollY;

        const isNear = Math.abs(current - finalPosition) < 10;

        // jeśli już jesteś na miejscu → nie rób nic
        if (isNear) return;

        const jumpPosition = finalPosition - 120;

        window.scrollTo(0, jumpPosition);

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                smoothScrollTo(finalPosition, 450);
            });
        });
    };

    // =========================
    // CLICK HANDLER
    // =========================
    const gtt = document.querySelectorAll("[data-target]");

    if (gtt.length) {
        const action = function (e) {
            e.preventDefault();

            const target = e.currentTarget.dataset.target;
            const offset = parseInt(e.currentTarget.dataset.offset || 0, 10);

            const exists = document.querySelector(target);

            if (exists) {
                window.runScroll(target, offset);
            } else {
                window.location.href = window.location.origin + '/' + target;
            }
        };

        gtt.forEach(el => el.addEventListener('click', action));
    }

    // =========================
    // OBSŁUGA KOTWICY PRZY WEJŚCIU NA STRONĘ
    // np. obszary.html#area
    // =========================
    if (window.__pendingHash) {
        const hash = window.__pendingHash; // np. "#area"

        // czekamy na pełne załadowanie (obrazki, fonty itd.),
        // żeby wysokości elementów były już finalne
        window.addEventListener('load', function () {
            // mały odstęp, żeby przeglądarka zdążyła
            // ułożyć layout po 'load'
            setTimeout(() => {
                window.runScroll(hash, 0);
                // jeśli chcesz inny offset dla scrolla z URL-a,
                // np. taki sam jak dla topbaru, wpisz go tutaj

                // przywracamy hash w adresie (bez ponownego scrolla)
                history.replaceState(null, '', hash);
            }, 50);
        });
    }

});